// Configuration des URLs Vercel pour les fonctions lourdes
// Détecte automatiquement l'environnement (production, preview, development)
const getVercelBaseUrl = () => {
  // En développement local, utiliser l'URL de preview si configurée
  // Sinon utiliser l'URL de production
  if (process.env.NODE_ENV === 'development') {
    // REACT_APP_VERCEL_PREVIEW_URL doit contenir "/api" à la fin
    // Ex: https://gie-consultants-react-git-xxx.vercel.app/api
    if (process.env.REACT_APP_VERCEL_PREVIEW_URL) {
      // Enlever /api si présent car on va le rajouter dans les URLs des fonctions
      return process.env.REACT_APP_VERCEL_PREVIEW_URL.replace(/\/api$/, '');
    }
    return process.env.REACT_APP_VERCEL_URL || 'https://gie-consultants-react-oxgrr.vercel.app';
  }

  // Variable d'environnement explicite (prioritaire)
  if (process.env.REACT_APP_VERCEL_URL) {
    return process.env.REACT_APP_VERCEL_URL;
  }

  // Détection automatique de l'URL Vercel
  // Vercel injecte automatiquement VERCEL_URL dans les deployments
  if (process.env.REACT_APP_VERCEL_DEPLOYMENT_URL) {
    return `https://${process.env.REACT_APP_VERCEL_DEPLOYMENT_URL}`;
  }

  // Fallback sur l'URL de production
  return 'https://gie-consultants-react-oxgrr.vercel.app';
};

const VERCEL_BASE_URL = getVercelBaseUrl();

export const VERCEL_FUNCTIONS = {
  DOWNLOAD_FACTURE_INTERNE: `${VERCEL_BASE_URL}/api/download-facture-interne`,
  UPLOAD_FACTURE_INTERNE: `${VERCEL_BASE_URL}/api/download-facture-interne`, // Alias - même endpoint pour upload
  SEND_FACTURE_EMAIL: `${VERCEL_BASE_URL}/api/send-facture-email`,
  E_INVOICING: `${VERCEL_BASE_URL}/api/e-invoicing`,
  E_INVOICING_INTERNE: `${VERCEL_BASE_URL}/api/e-invoicing-interne`,
  PREVIEW_FACTURE_PDF: `${VERCEL_BASE_URL}/api/preview-facture-pdf`,
  QONTO_OAUTH_START: `${VERCEL_BASE_URL}/api/qonto-oauth-start`,
  QONTO_REGISTER_WEBHOOKS: `${VERCEL_BASE_URL}/api/qonto-register-webhooks`,
  QONTO_OAUTH_DISCONNECT: `${VERCEL_BASE_URL}/api/qonto-oauth-disconnect`,
};

// Export pour debug
export const getVercelUrl = () => VERCEL_BASE_URL;
